import { createStyles } from 'antd-style';

import { ThemeColors, ThemeFont, ThemeSpaces } from '../theme';

export const useViewQuoteBreakdownDialogStyles = createStyles(({ token }) => ({
  viewQuoteBreakdownDialog: {
    '&&': {
      '.ant-modal-body': {
        padding: `0 0 ${ThemeSpaces.SPACE_NORM}px 0`,
      },
    },
  },
  controlButtons: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: `${ThemeSpaces.SPACE_NORM_20}px ${ThemeSpaces.SPACE_NORM_20}px 0 ${ThemeSpaces.SPACE_NORM_20}px`,

    '> h1': {
      fontSize: ThemeFont.FONT_SIZE_30,
      fontWeight: 300,
    },

    '&& > button': {
      fontWeight: 'normal',
      marginRight: -ThemeSpaces.SPACE_NORM,
      marginTop: -ThemeSpaces.SPACE_NORM,
    },
  },
  configurableCard: {
    height: '100%',
  },
  configurableCardBody: {
    padding: `${ThemeSpaces.SPACE_NORM0_5}px ${ThemeSpaces.SPACE_NORM}px`,
    display: 'inline-block',
    lineHeight: 1.3,
    width: '100%',
    height: 'calc(100% - 24px)',
  },
  scrollablePanel: {
    height: '600px !important',
    maxHeight: 'calc(100vh - 142px)',
  },
  scrollableContent: {
    padding: `0 ${ThemeSpaces.SPACE_NORM_15}px ${ThemeSpaces.SPACE_NORM}px ${ThemeSpaces.SPACE_NORM_20}px`,
  },
  quoteInfo: {
    lineHeight: 1.2,

    '> .ant-col': {
      '> div': {
        '&:first-child > span': {
          '&:first-child': {
            fontWeight: 700,
          },

          '&:last-child:not(:first-child)': {
            color: token.colorPrimary,
            fontWeight: 700,
          },
        },

        '> span:last-child': {
          marginLeft: token.marginXXS,
        },
      },

      '&:first-child > div:last-child > span:last-child': {
        color: token.colorPrimary,
        fontWeight: 700,
        marginLeft: token.marginXXS,
      },

      '&:last-child > div': {
        '&:nth-child(2) > span': {
          fontStyle: 'italic',
        },

        '&:nth-child(3) > span:last-child': {
          fontWeight: 700,
        },

        '> span:last-child:not(:first-child)': {
          marginLeft: token.marginXXS,
        },
      },
    },
  },
  itemizationSection: {
    marginTop: ThemeSpaces.SPACE_NORM0_5,

    '.ant-col': {
      h2: {
        fontSize: token.fontSizeHeading4,
        fontWeight: 300,
        textDecoration: 'underline',
        marginBottom: 0,
      },

      p: {
        lineHeight: 1.2,
      },

      '&:first-child': {
        paddingRight: `${ThemeSpaces.SPACE_XL}px !important`,

        div: {
          display: 'flex',
          justifyContent: 'space-between',
          lineHeight: 1.2,

          'span:last-child': {
            textTransform: 'uppercase',
          },
        },
      },
    },
  },
  noticeSection: {
    marginTop: token.marginXS,

    '> p': {
      fontSize: ThemeFont.FONT_SIZE_SM_PLUS,
      fontWeight: 500,
      textTransform: 'uppercase',
    },

    '> span': {
      fontSize: ThemeFont.FONT_SIZE_SM_MINUS,
      fontStyle: 'italic',
      lineHeight: 1.3,
      display: 'inline-block',
    },
  },
  addressSection: {
    marginTop: 18,
    marginBottom: ThemeSpaces.SPACE_NORM,
  },
  piecesSectionPreview: {
    padding: '5px 0',

    '.ant-col': {
      fontSize: token.fontSizeLG,
      color: ThemeColors.COLOR_GREY_BLUISH2,

      '&:nth-child(2)': {
        textAlign: 'center',
      },

      '&:last-child': {
        textAlign: 'end',
      },

      '> span:last-child': {
        marginLeft: token.marginXXS,
        fontWeight: 700,
      },
    },
  },
  newQuotePackageHeaderOverride: {
    '&&': {
      margin: `0 -${ThemeSpaces.SPACE_NORM}px`,
      backgroundColor: ThemeColors.COLOR_WHITE8,
      fontSize: token.fontSize,

      '.ant-col': {
        fontFamily: 'inherit',
      },
    },
  },
  packagePreviewBodyOverride: {
    '&&': {
      padding: '5px 0',
    },
  },
  billedWeightOverride: {
    color: ThemeColors.COLOR_GREY_BLUISH2,
  },
  billedWeightValueOverride: {
    color: token.colorPrimary,
  },
}));
